type RequestId = string;
const sainUsageEventStore: Map<RequestId, true> = new Map();
const MAX_EVENTS = 10;

// React listeners for useSyncExternalStore
const listeners = new Set<() => void>();

function emitChange() {
	listeners.forEach((listener) => listener());
}

export function subscribe(listener: () => void) {
	listeners.add(listener);
	return (): boolean => listeners.delete(listener);
}

export function getSnapshot(): Map<RequestId, true> {
	return sainUsageEventStore;
}

/**
 * Marks a requestId as fired.
 * Maintains only the last MAX_EVENTS request IDs.
 */
export function markFired(requestId: RequestId): void {
	if (!sainUsageEventStore.has(requestId)) {
		sainUsageEventStore.set(requestId, true);

		if (sainUsageEventStore.size > MAX_EVENTS) {
			const oldestKey = sainUsageEventStore.keys().next().value;
			if (oldestKey) {
				sainUsageEventStore.delete(oldestKey);
			}
		}

		emitChange();
	}
}
